import { createStyles } from '../../core/withStyles';
const styles = (theme) => createStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        height: '100%',
        marginRight: theme.spacing(2),
    },
});
export default styles;
//# sourceMappingURL=MenuLogo.styles.js.map